// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center[data-v-3f066b3f]{\r\n  max-width:1024px;\r\n  margin:0 auto;\n}\n.link[data-v-3f066b3f] {\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  color: blue;\n}\r\n", ""]);
// Exports
module.exports = exports;
